import { Box,IconButton, MenuItem, Select, Typography } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { getCurrencies, getLanguages } from "../services/apiCalls";
import { CurrencyContext } from "../context/CurrencyContext";
import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  AccountCircleOutlined
} from "@mui/icons-material";
const TopBar = () => {
  const [languages, setLanguages] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const { selectedCurrency, setSelectedCurrency } = useContext(CurrencyContext);
  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await getLanguages();
        setLanguages(response.data.languages);
        setSelectedLanguage(response.data.default_language);
      } catch (error) {
        console.error("Error fetching languages:", error);
      }
    };
    fetchLanguages();
  }, []);
  const handleProfileClick = () => {
    if (user) {
      navigate("/profile");
    } else {
      navigate("/signin");
    }
  };

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const response = await getCurrencies();
        setCurrencies(response.data.currencies);
        setSelectedCurrency(response.data.default_currency);
      } catch (error) {
        console.error("Error fetching currencies:", error);
      }
    };
    fetchCurrencies();
  }, []);

  const handleLanguageChange = (event) => {
    const newLanguage = languages.find(
      (lang) => lang.code === event.target.value
    );
    setSelectedLanguage(newLanguage);
  };

  const handleCurrencyChange = (event) => {
    const newCurrency = currencies.find(
      (curr) => curr.code === event.target.value
    );
    setSelectedCurrency(newCurrency);
  };

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-[#313131] text-white text-sm">
      {/* Left Section */}
      <div className="flex items-center">
        {/* <img
          alt="Fire icon"
          className="mr-2"
          height="20"
          src="https://storage.googleapis.com/a1aa/image/zhg20Zx70L6OO5JXIvo2qTL2wdQmSwPDAlERdQKtEO2tlpAF.jpg"
          width="20"
        /> */}
        <span className="hidden sm:block">
          Elegant Furniture Crafted For Your Dream Home
        </span>
      </div>

      <div className="flex items-center">
        <span className="hidden sm:block">tcomputerzone@gmail.com</span>
      </div>

      {/* Right Section */}
      <div className="flex items-center space-x-4 text-white">
        <div className="relative">
          <Select
            value={selectedLanguage?.code || ""}
            onChange={handleLanguageChange}
            className="bg-transparent text-white text-sm focus:outline-none cursor-pointer uppercase"
            displayEmpty
            
          >
            {languages.map((lang) => (
              <MenuItem
                key={lang.id}
                value={lang.code}
                className="bg-white text-black"
                
              >
                {lang.name.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        </div>

        <span>|</span>

        <div className="relative">
          <Select
            value={selectedCurrency?.code || ""}
            onChange={handleCurrencyChange}
            className="bg-transparent text-white text-sm focus:outline-none cursor-pointer uppercase"
            displayEmpty
            
          >
            {currencies.map((curr) => (
              <MenuItem
                key={curr.id}
                value={curr.code}
                className="bg-white text-black "
                
              >
                {curr.code.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        </div>
        <span className="hidden sm:block">|</span>

        <div className="flex items-center">
         {/* <img
          alt="Fire icon"
          className="mr-2"
          height="20"
          src="https://storage.googleapis.com/a1aa/image/zhg20Zx70L6OO5JXIvo2qTL2wdQmSwPDAlERdQKtEO2tlpAF.jpg"
          width="20"
        />  */}
        <span className="hidden sm:block">
          <IconButton onClick={handleProfileClick} className="text-white">
            <AccountCircleOutlined className="text-white" />
            <p className="hidden sm:block text-white text-sm ml-2">
             Log   In
            </p>
          </IconButton>
        </span>

      </div>

      
      </div>
    </div>
  );
};

export default TopBar;
